import { Component, OnInit, AfterViewInit, OnDestroy, Input, Output, EventEmitter, Inject } from '@angular/core';

import { Location, DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs/internal/Subscription';
import { NotificationService } from 'notification';
import { ApiService, ProfileService } from 'profile';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PlatformService } from '../../services/platform.service';
import { AppManagerService } from 'app-manager';
import { SharedService } from '../../services/shared.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-universal-nav',
  templateUrl: './universal-nav.component.html',
  styleUrls: ['./universal-nav.component.scss']
})
export class UniversalNavComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() SideNavData: any;
  @Input() RightNavData: any;
  @Input() removeActiveVal: any;
  @Input() profile: string;
  @Input() homePage: boolean;
  @Output() childEvent = new EventEmitter();
  @Output() langEvent = new EventEmitter();
  @Output() login = new EventEmitter();
  //dialogRef: MatDialogRef<SearchScreenComponent, any>;
  isShow = false;
  profileData: any;
  isExpanded: boolean;
  cActiveVal: boolean;
  status: boolean = false;
  apiURL: any;
  isRightNavExp = false;
  isLoginClicked = false;
  @Input() cLang: string;
  hideMainMnu: string;
  initialLanguage: string;
  appTitle: string = 'Health Platform';
  isDashboard: boolean = false;
  getuserProfileDetails: any;
  profileName;
  userDetails: any;
  supportedLanguages: any;
  imagUrl: any;
  forRestrictView: boolean;
  userName: string;
  subscription: Subscription;
  subscriptionCount: Subscription;
  userdetailsubscription: Subscription;
  expandViewData: Subscription;
  subscriptionLogin: Subscription;
  subscriptionProfileUpdation: Subscription;
  fullName: string;
  userType: string = '';
  passData: any = {
    key: "",
    val: ""
  }
  dataSource: any;
  nCount: number = 0;
  dataToPass: string;

  constructor(private _http: NotificationService,
    private apiService: ApiService,
    private location: Location,
    private dataService: LayoutService,
    private translate: TranslateService,
    private auth: AuthService,
    private userdetailsservice: ProfileService,
    private dialogBox: MatDialog,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private platformService: PlatformService,
    private appManagerService: AppManagerService,
    private sharedService: SharedService) { }
  ngOnInit() {
    // if (this.auth.loggedIn()) {
    //   this.profileData = this.auth.getUserProfileObject();
    //   this.supportedLanguages = JSON.parse(localStorage.getItem('langObject'));
    //   for (var i = 0; i < this.supportedLanguages.length; i++) {
    //     if (this.supportedLanguages[i].name.toLowerCase() == this.profileData.preferredLanguage.toLowerCase()) {
    //       var lan = this.supportedLanguages[i].description.toLowerCase().split("-");
    //       if (lan.length > 1) {
    //         if (lan[0].toLowerCase() == lan[1].toLowerCase()) {
    //           localStorage.setItem('Lang', lan[0].toLowerCase());
    //         } else {
    //           localStorage.setItem('Lang', this.supportedLanguages[i].description.toLowerCase());
    //         }
    //       } else {
    //         localStorage.setItem('Lang', this.supportedLanguages[i].description.toLowerCase());
    //       }
    //     } else {
    //       localStorage.setItem('Lang', this.supportedLanguages[i].description.toLowerCase());
    //     }
    //   }

    //   this.translate.use(localStorage.getItem('Lang'));
    //   this.initialLanguage = localStorage.getItem('Lang').toUpperCase();
    //   this.document.documentElement.lang = localStorage.getItem('Lang').toLowerCase();
    // }
    // if (localStorage.getItem('Lang') == null) {
    //   this.translate.use('en')
    // }
    this.apiService.apiUrl = environment.PLATFORM_AUTH;
    // if (localStorage.getItem('Application') == null || localStorage.getItem('Application') == undefined || this.homePage) {
    //   this.hideMainMnu = "dashboard";
    //   this.appTitle = 'Digital Hartmann Health Platform';
    // } else {
    //   this.appTitle = 'Care Management';
    // }
    this.dataService.currentMainMenuValue.subscribe((data: any) => {
      this.isDashboard = data.mainView;
      //this.appTitle = data.appTitle;
    })
    this.subscriptionLogin = this.dataService.getProfileData$.subscribe(data => {
      if (Object.keys(data).length) {
        if (data.firstName && data.lastName) {
          this.profileName = data.firstName.charAt(0) + '' + data.lastName.charAt(0);
        }
        this.fullName = data.firstName ? data.firstName + ' ' + data.lastName : 'User Name';
        this.userType = data.accountType;
      }
    });
    this.dataService.currentActiveValue.subscribe((data) => {
      this.cActiveVal = data;
    })
    this.subscription = this.dataService.userDisplay$.subscribe(data => {
      //this.fullName = data;
    })
    this.dataService.currentExpantValue.subscribe(data => {
      this.isExpanded = data;
    })
    this.userdetailsubscription = this.userdetailsservice.completeUserData$.subscribe(res => {
      this.imagUrl = res.profileImage;
    })
    //this.fullName = this.auth.getDisplay();
    // notification start
    this.subscriptionCount = this._http.notificationCount$.subscribe({
      next: (data: any) => {
        //if (data > 0) {
        this.dataSource = data;
        this.nCount = this.dataSource;
        //}
      },
      error: err => { },
      complete: () => { }
    });
    // notification start end
  }
  getChangedLanguage(value) {
    this.langEvent.emit(value);
    this.document.documentElement.lang = value.toLowerCase();
  }
  getFeaturesData(roleId) {
    if (roleId != '')
      this.platformService.getRoleProfileById(roleId).subscribe({
        next: res => {
          if (res) {
            this.dataService.getProfileRoleData.next(res.features);
            this.dataService.userRoleData = res.features;
            this.dataService.getRoleValueAccess.next(true);
          }
        },
        error: err => {
          if (!!err && err.status == 500) {
          }
        }
      })

  }
  ngOnChanges(): void {
    if (!!localStorage.getItem('Lang')) {
      this.initialLanguage = localStorage.getItem('Lang')?.toUpperCase();
    }
     else if (this.cLang != undefined) {
      this.initialLanguage = this.cLang?.toUpperCase();
    } else {
      this.initialLanguage = localStorage.getItem('Lang')?.toUpperCase();
    }

    this.expandViewData = this.dataService.mainMenuView$.subscribe((data) => {
      this.forRestrictView = data;
    });
  }

  changeCountry() {
    this.toggleNav();
    this.passData = { key: "language", val: true }
    this.childEvent.emit(this.passData);
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    if (this.subscriptionCount)
      this.subscriptionCount.unsubscribe();
    if (this.userdetailsubscription)
      this.userdetailsubscription.unsubscribe();
    if (this.expandViewData)
      this.expandViewData.unsubscribe();
    if (this.subscriptionLogin)
      this.subscriptionLogin.unsubscribe();
  }
  toggleNav() {
    this.appManagerService.refreshIndex.next(true);
    this.dataService.changeActiveValue(false);
    this.RightNavData.toggle();
    this.isRightNavExp = !this.isRightNavExp;
    this.status = this.RightNavData.opened;
  }

  onChangeSideNav(event) {
    switch (event.event) {
      case 'sidenavAction':
        if (!this.forRestrictView) {
          this.isExpanded = !this.isExpanded;
          this.dataService.changeExpandValue(this.isExpanded)
        } else {
          this.location.back();
        }
        break;
    }
  }
  changeMenuEvent(event) {
    switch (event.event) {
      case 'changeApp':
        // this.toggleNav();
        // this.passData = { key: "app", val: true }
        // this.childEvent.emit(this.passData);
        break;
      case 'changeAlert':
        // this.passData = { key: "alert", val: true }
        break;
      case 'changeLanguage':
        this.passData = { key: "language", val: true }
        this.childEvent.emit(this.passData);
        break;
      case 'changeProfile':
        this.toggleNav();
        this.dataService.changeRightNavExp(true);
        this.passData = { key: "profile", val: true }
        this.childEvent.emit(this.passData);
        break;
      case 'changeContact':
        // this.passData = { key: "contact", val: true }
        // this.childEvent.emit(this.passData);
        break;
      case 'changeHelp':
        // this.router.navigateByUrl('/faq');
        break;
      case 'showConcent':
        this.consentView('');
        break;
    }
  }

  loginclick() {
    this.isLoginClicked = true;
    this.login.emit(this.isLoginClicked);
  }
  ngAfterViewInit() {

  }
  consentView(data) {
   
  }
}
